import { ArgsType } from '@nestjs/graphql'
import { BaseDeleteDto } from '../base/baseDelete.dto'

@ArgsType()
export class DeleteArcTeamDto extends BaseDeleteDto<DeleteArcTeamDto> { }
